<template>
 <v-container>
   <v-layout text-xs wrap>
     <v-flex xs12>
       <div class="success-message">
         <h2>Sorry, you are not eligible</h2>
         <h3>Based on the information you entered, your child is not eligible for free Pre-K programs, however, you may be eligible for the SC Working Families Child Care Scholarship. If you would like information on child care programs that may meet your family needs, please contact the SC Working Families Child Care Scholarship Program at 
           <a href="tel:8004760199">800-476-0199</a> for more information.</h3>
       </div>
     </v-flex>
   </v-layout>
 </v-container>
</template>

<script>

export default {
  name: 'eligible',
  components: {},
  data() {
    return {
      first_steps_eligible_19: false,
      first_steps_eligible_20: false,
      head_start_eligible: false,
      dept_ed_eligible: false,
      voucher_eligible: false,
      school_district: "",
      any_eligible: false
    };
  },
  mounted: function(){
    this.first_steps_eligible_19 = (localStorage.getItem('first_steps_19') === 'true');
    this.first_steps_eligible_20 = (localStorage.getItem('first_steps_20') === 'true');
    this.head_start_eligible = (localStorage.getItem('head_start') === 'true');
    this.dept_ed_eligible = (localStorage.getItem('dept_ed') === 'true');
    this.voucher_eligible = (localStorage.getItem('voucher') === 'true');
    this.school_district = localStorage.getItem('district');

    if(this.first_steps_eligible_19 || this.first_steps_eligible_20 || this.head_start_eligible || this.dept_ed_eligible || this.voucher_eligible){
      this.any_eligible = true;
     
      this.$gtag.event('conversion',  {'send_to': 'AW-670219579/jbB2COuo-MIBELv6yr8C'});
    }
  },
  methods:{
    programClick(){
      this.$router.push({ path: 'provider-search'});
    }
  }
}
</script>

<style scoped>
.about {
  padding-top: 15px;
}
.success-image{
  text-align:center;
}
.success-image img{
  width: 50%;
  height: auto;
}
.logo-row{
  padding-top: 25px;
}
</style>